import type { NetBuyView } from "../types";
import { TierPortrait, tierIdentities } from "../../../components/TierPortrait";
import { formatUsdExact } from "../../../components/format";
import { Overlay } from "../../../components/overlays/Overlay";
import { formatRewardRate } from "../../../lib/reward-format";

// Published V2 reference bounds from contracts/src/WeightedRewardPolicyV2.sol.
// This catalog is display-only; live mint/redeem flows use verified policy data.
const referenceRangesPpm: Readonly<Record<number, { min: number; max: number }>> = {
  10: { min: 50, max: 150 },
  100: { min: 150, max: 500 },
  500: { min: 500, max: 1_500 },
  1_000: { min: 1_500, max: 4_000 },
  2_000: { min: 4_000, max: 8_000 },
  5_000: { min: 10_000, max: 20_000 },
};

export function TierGuideDrawer({ open, netBuy, onClose }: {
  open: boolean;
  netBuy: NetBuyView;
  onClose(): void;
}) {
  return (
    <Overlay open={open} onClose={onClose} title="Mining NFT tiers" eyebrow="THE SIX RANGERS" variant="sheet" className="tier-guide">
      <p className="drawer-lead">Explore the six mining tiers and their published reward ranges. These ranges are a reference; the final rate is determined on-chain when you mint.</p>
      <ol className="tier-guide-list" aria-label="Mining NFT tiers">
        {tierIdentities.map((identity, index) => {
          const reward = referenceRangesPpm[identity.tier];
          const threshold = netBuy.netBuyThresholds?.find(tier => tier.tierUsd === identity.tier);
          return <li key={identity.tier} className={`tier-guide-row tier-guide-${identity.tier}`}>
            <TierPortrait tier={identity.tier} className="tier-guide-portrait" />
            <div className="tier-guide-info">
              <span className="tier-guide-number">Tier {index + 1} <span>· ${identity.tier.toLocaleString("en-US")}</span></span>
              <h3>{identity.name}</h3>
              <dl>
                <div><dt>Reward range</dt><dd className="tier-guide-reward">{reward ? `${formatRewardRate(reward.min, 1_000_000)} – ${formatRewardRate(reward.max, 1_000_000)}` : "Unavailable"}</dd></div>
                {threshold ? <div><dt>Minimum net buy</dt><dd>{formatUsdExact(threshold.minNetBuyUsd)}</dd></div> : null}
              </dl>
            </div>
          </li>;
        })}
      </ol>
      <p className="modal-footnote">Reward rates apply to the available source-token pool at redemption. Tier labels are not mint prices; mint fees and gas are separate. Current eligibility is checked before minting.</p>
    </Overlay>
  );
}
